import React, { Component } from 'react';
import './index.scss';

import Card from 'material-ui/Card';
import Grid from 'material-ui/Grid';

import List, { ListItem, ListItemText } from 'material-ui/List';
import Collapse from 'material-ui/transitions/Collapse';

import {observer,inject} from 'mobx-react';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography'

const styles = theme => ({
    textFieldInput : {
        fontSize : 18
    },
    textFieldFormLabel : {
        fontSize : 20
    },
    text: {
        fontSize: 14
    }
});

@inject("summaryDataStore")
@observer
class CardDetail extends Component {

    constructor(props) {
        super(props)
        this.state = {
            open: 0,
            current: 0,
            setChild: []
        }
    }

    handleClick = (i) => {
        const { current } = this.state;
        if(current === i){
            this.setState({ open: 0, current: 0 });
        } else {
            this.setState({ open: i, current: i });
        }
    };


    _renderChild_2(data,index){
        let numList = 0;
        for(let item in data) {
            numList++;
            if(index === 0 || (index === 1 && numList === 2) || (index === 2 && numList === 3) || (index === 3 && numList === 4)){
                return (
                    <ListItem>
                        <ListItemText primary={<Typography type="body1" style={{ fontSize:'1.75rem',fontFamily: 'DB Heavent' }}>&nbsp;&nbsp;{item}</Typography>} key={item+numList} />
                        <div className='text'> {data[item]} </div>
                    </ListItem>
                )
            }
        }
    }

    _renderChild_1(data){
        let numList = 1;
        for(let key in data) {
            numList++;
            return (
                <ListItem>
                    <ListItemText primary={<Typography type="body1" style={{ fontSize:'1.75rem',fontFamily: 'DB Heavent' }}>{key}</Typography>} key={key+numList} />
                    <div className='text'> {data[key]} </div>
                </ListItem>
            )
        }
    }

    render() {
        const { open } = this.state;
        const { info } = this.props.summaryDataStore;
        let numList = 1;
        return (
            <Card className='cardDetail'>
                <div className='alignCenter'>
                <Grid container className='containerGrid' justify="center" spacing={0} >
                    {/*<Grid xs={1} sm={1}  md={1}> </Grid>*/}
                    <Grid xs={10} sm={10} md={10}>
                        <br/>
                        <h1 className='headerCard'> รายละเอียดการติดตั้ง </h1>
                        <List key='list'>
                            {
                                info.map((data, key) => {
                                    if(data.detail){
                                        for(let keys in data) {
                                            if(keys !== 'detail') {
                                                return (
                                                    <div key={numList+key}>
                                                        <ListItem button onClick={() => this.handleClick(key+1)}>
                                                            <ListItemText primary={<Typography type="body1" style={{ fontSize:'1.9rem',fontFamily: 'DB Heavent' }}>{keys}</Typography>} />
                                                            <div className='text'> {data[keys]} &nbsp; {open === key+1 ? <img src="assets/icons8-chevron_up_round.png" alt="chevron_up_round" className="upDownButton" /> : <img src="assets/icons8-chevron_down_round.png" alt="upDownButton" className="upDownButton" />}</div>
                                                        </ListItem>
                                                        <Collapse component="li" in={open === key+1} timeout="auto" unmountOnExit>
                                                            <List disablePadding>
                                                                {
                                                                    Object.keys(data.detail).map((value, index)=> {
                                                                        return (
                                                                            this._renderChild_2(data.detail,index)
                                                                        )
                                                                    })
                                                                }
                                                            </List>
                                                        </Collapse>
                                                    </div>
                                                )
                                            }
                                        }
                                    } else {
                                        return this._renderChild_1(data)
                                    }
                                    return true;
                                })
                            }
                        </List>
                    </Grid>
                </Grid>
                </div>
            </Card>
        );
    }
}

export default withStyles(styles)(CardDetail);



// WEBPACK FOOTER //
// ./src/components/summary/cardDetail.js